import { flashAlert, notifyError } from "../flash_alert";
import { redirectTo } from "../../utils/misc";
import { PROCESSING_PAYMENT_INTENT_STATUS, SUCCEEDED_PAYMENT_INTENT_STATUS } from "../../utils/constants";
import { stripeClient } from "../../utils/api_clients";

class FinalizeSubscription {
  constructor(subscriptionData, loaderElement, submitBtn, paymentErrorMsg) {
    this.paymentIntent = subscriptionData.payment_intent;
    this.paymentMethod = subscriptionData.payment_method;
    this.callbackUrl = subscriptionData.callback_url;
    this.redirectionUrl = subscriptionData.redirection_url;
    this.loaderElement = loaderElement;
    this.submitBtn = submitBtn;
    this.paymentErrorMsg = paymentErrorMsg;
  }

  call() {
    this.stripeClient = stripeClient();

    if (!this.paymentIntent || this._validPaymentIntent(this.paymentIntent)) {
      this._onSubscriptionPayment();
    } else {
      this._confirmStripePayment();
    }
  }

  _onSubscriptionPayment() {
    fetch(this.callbackUrl, {
      method: "POST",
      headers: {
        "X-CSRF-Token": Rails.csrfToken(),
        "Content-Type": "application/json",
      },
    }).then(() => {
      flashAlert("Merci, votre paiement a bien été pris en compte !");
      redirectTo(this.redirectionUrl);
    });
  }

  _confirmStripePayment() {
    const paymentMethod = this.paymentMethod;
    if (this._isSepa(paymentMethod)) {
      this._confirmSepa(paymentMethod);
    } else {
      this._confirmCard(paymentMethod);
    }
  }

  _isSepa(paymentMethod) {
    return paymentMethod.type === "sepa_debit";
  }

  _confirmSepa(paymentMethod) {
    this.stripeClient
      .confirmSepaDebitPayment(this.paymentIntent.client_secret, {
        payment_method: paymentMethod.stripe_id,
      })
      .then((result) => this._handlePaymentConfirmationResponse(result));
  }

  _confirmCard(paymentMethod) {
    this.stripeClient
      .confirmCardPayment(this.paymentIntent.client_secret, {
        payment_method: paymentMethod.stripe_id,
      })
      .then((result) => this._handlePaymentConfirmationResponse(result));
  }

  _handlePaymentConfirmationResponse(response) {
    if (response.error) {
      this._handleErrors(response.error.message);
    } else {
      if (this._validPaymentIntent(response.paymentIntent)) {
        this._onSubscriptionPayment();
      } else {
        this._handleErrors("Une erreur est survenue, veuillez réessayer ultérieurement.");
      }
    }
  }

  _validPaymentIntent(paymentIntent) {
    return [SUCCEEDED_PAYMENT_INTENT_STATUS, PROCESSING_PAYMENT_INTENT_STATUS].includes(paymentIntent.status);
  }

  _handleErrors(errorMsg) {
    notifyError(
      "La tentative de paiement a échoué, veuillez réessayer ou contacter un membre de l'équipe Qonto Comptabilité by Acasi Accounting."
    );
    this.submitBtn.classList.remove("hidden");
    this.loaderElement.classList.add("hidden");
    this.paymentErrorMsg.textContent = errorMsg;
  }
}

export default FinalizeSubscription;
